import { Stack, Typography } from "@mui/material";
import { useFormatter } from "../../../utils/useFormatter";
import { Place, VideoCameraFront } from "@mui/icons-material";
import { useOrganizationContext } from "../../../contexts/OrganizationContext";

interface IProps {
  location: fhir5.Location;
}

export function HeaderScheduling({ location }: IProps) {
  function isExtensionVirtualService(extension: fhir5.Extension) {
    return (
      extension.url ===
        "https://fluxmed.com.br/fhir/StructureDefinition/virtual-service" &&
      extension.valueBoolean === true
    );
  }

  function isVirtualService(location: fhir5.Location) {
    return !!location?.extension?.find(isExtensionVirtualService);
  }

  const { organizationList } = useOrganizationContext();
  const findOrganization = organizationList?.find(
    (org) =>
      org?.resource?.id ===
      location?.managingOrganization?.reference?.split("/")?.[1]
  );

  return (
    <Stack width="100%" borderRadius="5px" mb={1}>
      <Stack direction="row" width="100%" gap={2}>
        <Stack width="100%" direction="column" justifyContent="center" spacing={0.5}>
          <Typography
            variant="subtitle2"
            fontWeight={700}
            color="neutral700.main"
          >
            {useFormatter.formatNameDisplay(
              findOrganization?.resource?.alias?.[0] ||
                findOrganization?.resource?.name ||
                "-"
            )}
          </Typography>

          <Stack direction="row" alignItems="center" width="100%" spacing={1}>
            {!isVirtualService(location) ? (
              <Stack direction="row" alignItems="center" spacing={1}>
                <Place fontSize="small" sx={{ color: "neutral700.main" }} />
                <Typography
                  variant="body2"
                  color="neutral700.main"
                  sx={{ wordBreak: "break-word" }}
                >
                  {location?.address?.line?.join(", ")}
                </Typography>
              </Stack>
            ) : (
              <Stack direction="row" alignItems="center" spacing={1}>
                <VideoCameraFront fontSize="small" sx={{ color: "neutral700.main" }} />
                <Typography variant="body2" color="neutral700.main">
                  Remoto
                </Typography>
              </Stack>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
